import { FunctionComponent } from 'react';

import { AreaChart as RechartsAreaChart, Area as RechartsArea } from 'recharts';

import { IGenericChartProps } from './Chart';

const AreaChart: FunctionComponent<IGenericChartProps> = (props: IGenericChartProps) => {
    return (
        <RechartsAreaChart
            data={props.data}
            width={props.width}
            height={props.height}
            className='chart'
            margin={{ left: -20 }}
        >
            {props.children}
            {
                props.dataKeys
                    .filter(x => props.disabledKeys.indexOf(x.dataKey) < 0)
                    .map(dataKey => (
                        <RechartsArea
                            key={dataKey.dataKey}
                            type="monotone"
                            name={dataKey.legendName}
                            dataKey={dataKey.dataKey}
                            stroke={`var(--color-${dataKey.color})`}
                            fill={`rgba(var(--color-${dataKey.color}-rgb), 0.7)`}
                            activeDot={{ r: 3 }}
                            id={dataKey.dataKey}
                            stackId={dataKey.stackKey}
                            animationDuration={500}
                            animationBegin={0}
                        />
                    ))
            }
        </RechartsAreaChart>
    )
};

export default AreaChart;